import { render, staticRenderFns } from "./Hint-Paste.vue?vue&type=template&id=56f8c350&scoped=true&"
import script from "./Hint-Paste.vue?vue&type=script&lang=js&"
export * from "./Hint-Paste.vue?vue&type=script&lang=js&"
import style0 from "./Hint-Paste.vue?vue&type=style&index=0&id=56f8c350&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f8c350",
  null
  
)

export default component.exports